//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { Notify } from "quasar";
import { PLATFORM_BASE_PATH } from "@/assets/js/appConfig";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import SetAccessibility from "@/pages/login/views/Login/SetAccessibility.vue";
import { $http } from "@/assets/js/appFunc";

export default {
    components: {
        AQButton,
        AQAvatar,
        AQInput,
        SetAccessibility
    },
    beforeRouteEnter(to, from, next) {
        next(vueInstance => {
            const vm = vueInstance;
            if (to.params && to.params.username) {
                vm.userEmailLogin = to.params.username;
                vm.twoFactorId = to.params.twoFactorId;
                vm.phoneNo = to.params.phoneNo;
                vm.captchaToken = to.params.captchaToken;
                vm.language = to.params.language;
                vm.colorsAccessibility = to.params.colorsAccessibility;
                vm.pid = to.params.pid;
                vm.fileName = to.params.fileName;
                vm.isFromResetPass = to.params.isFromResetPass;
            }
        });
    },
    data() {
        return {
            loginErrorMessage: null,
            emailErr: false,
            accessCode: "",
            accessCodeEmpty: false,
            wrongAccessCode: false,
            expiredAccessCode: false,
            newAccessCodeRequested: false,
            countDown: 60,
            userEmailLogin: "",
            phoneNo: "",
            captchaToken: "",
            language: "",
            colorsAccessibility: false,
            twoFactorId: "",
            pid: "",
            fileName: "",
            isFromResetPass: false
        };
    },
    computed: {
        ...mapGetters("main", ["getShowAccessibilityOption"]),
        accessCodeValidator() {
            let errorMsg = "";
            if (this.wrongAccessCode) {
                errorMsg = this.$t("login.wrongAccessCode");
            } else if (this.accessCodeEmpty) {
                errorMsg = this.$t("login.emptyAccessCode");
            } else if (this.expiredAccessCode) {
                errorMsg = this.$t("login.expiredAccessCode");
            }
            return errorMsg;
        },
        smsText() {
            return this.$t("login.twoFactorAuthBodyMsg", { phoneNo: this.phoneNo });
        }
    },
    watch: {
        userEmailLogin: {
            handler() {
                this.emailErr = false;
            },
            immediate: true
        }
    },
    created() {
        this.newAccessCodeRequested = true;
        this.countDownTimer();
    },
    methods: {
        ...mapActions("main", ["getMultiFeaturesOption"]),
        ...mapActions("admin", ["twoFactorCode", "generateCode", "validateCode", "getUserWallet"]),
        redirectToLogin() {
            const pid = localStorage.getItem("ifPid");
            this.linkSent = false;
            this.$emit("linkSent", this.linkSent);

            localStorage.removeItem("ifPid");
            if (pid) {
                this.$router.push({ name: "start", params: { username: this.userEmailLogin, initialState: true }, query: { processDefinitionId: pid } });
            } else {
                this.$router.push({ name: "login", params: { username: this.userEmailLogin, initialState: true } });
            }
        },
        generateNewAccessCode() {
            this.generateCode({ twoFactorId: this.twoFactorId }).then(() => {
                this.countDown = 60;
                this.newAccessCodeRequested = true;
                this.countDownTimer();
            }).catch(() => {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$i18n.t("login.errorGenerate")
                });
            });
        },
        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1;
                    this.countDownTimer();
                }, 1000);
            } else {
                this.newAccessCodeRequested = false;
            }
        },
        removeAccessCodeErros() {
            this.wrongAccessCode = false;
            this.expiredAccessCode = false;
            this.accessCodeEmpty = false;
        },
        checkAccessibility() {
            let accessibility = null;
            if (this.getShowAccessibilityOption) {
                if (localStorage.changedAccessibility === "true") {
                    accessibility = localStorage.accessibility;
                }
            }
            return accessibility ? accessibility === "true" : accessibility;
        },
        checkAccessCode() {
            if (!this.accessCode) {
                this.accessCodeEmpty = true;
            } else {
                this.getMultiFeaturesOption().then(data => {
                    const accessibilityObj = data.data.find(item => item.code === "ACCESSIBILITY");
                    localStorage.setItem("accessibilityFeature", accessibilityObj.enabled);
                });
                this.twoFactorCode({
                    twoFactorId: this.twoFactorId,
                    twoFactorCode: this.accessCode,
                    captchaToken: this.captchaToken,
                    language: this.language,
                    colorsAccessibility: this.checkAccessibility(),
                    skip: false
                }).then(() => {
                    if (this.pid) {
                        $http({
                            url: `/engine/api/processDefinition/${this.pid}/start`,
                            type: "GET"
                        }, true).then(({ newData }) => {
                            const data = newData;
                            if (data.guiId && data.taskId) {
                                localStorage.removeItem("ifPid");
                                this.$store.dispatch("components/claimTask", data.taskId, { root: true }).then(rsp => {
                                    data.canUnclaim = rsp.data.canUnclaim;
                                    data.__dashboard = true;
                                    window.location.assign(`/${PLATFORM_BASE_PATH}/tasks/${data.taskId}`);
                                });
                            } else {
                                Notify.create({
                                    type: "success",
                                    position: "bottom-left",
                                    message: this.$i18n.t("apps.noPermisionsToStartApp"),
                                    actions: [{ icon: "close" }]
                                });
                            }
                        });
                    } else {
                        const taskId = localStorage.getItem("taskId");
                        this.$resetCaptcha();
                        if (taskId) {
                            window.location.assign(`/task?id=${taskId}`);
                        } else if (this.fileName) {
                            window.location.assign(`/${PLATFORM_BASE_PATH}/export?fileName=${this.fileName}`);
                        } else if (this.createUserId) {
                            window.location.assign(`/${PLATFORM_BASE_PATH}/userProfile`);
                            localStorage.removeItem("createUserId");
                        } else if (this.isFromResetPass) {
                            this.validateCode({ twoFactorId: this.twoFactorId, code: this.accessCode })
                                .then(() => {
                                    this.$router.push({
                                        name: "passReset",
                                        params: {
                                            username: this.userEmailLogin
                                        }
                                    });
                                })
                                .catch((err) => {
                                    if (err.response && err.response.data) {
                                        this.error = err.response.data;
                                    }
                                });
                        } else {
                            const size = window.innerWidth;
                            if (size < this.$q.screen.sizes.sm) {
                                window.location.assign(`/${PLATFORM_BASE_PATH}/tasks`);
                            } else {
                                this.getUserWallet(this.userEmailLogin).then(dataWallet => {
                                    if (dataWallet.data) {
                                        this.$router.push({ name: "changeWalletPassword" });
                                    } else {
                                        window.location.assign(`/${PLATFORM_BASE_PATH}/`);
                                    }
                                });
                                localStorage.removeItem("localIsSmallScreen");
                            }
                        }
                        this.accessCode = "";
                        localStorage.setItem("lastUserLogged", this.userEmailLogin.toLowerCase());
                    }
                }).catch((err) => {
                    if (err.response && err.response.data) {
                        if (err.response.data.error === "Invalid authentication code") {
                            this.wrongAccessCode = true;
                        } else if (err.response.data.error === "Your authentication code has expired. Please generate a new authentication code") {
                            this.expiredAccessCode = true;
                        }
                    }
                });
            }
        }
    }

};
